// Firebase configuration and initialization
// Environment-specific configuration from Issue #38

import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { appConfig, isDevelopment } from './env';

// Initialize Firebase app with environment-specific configuration
export const app = initializeApp(appConfig.firebase);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Connect to Firebase emulators in development environment
// Skip emulators if USE_REAL_FIREBASE is set (for testing real email)
// OR if VITE_USE_LIVE_BACKEND environment variable is set (for E2E tests)
const useRealFirebase =
  (typeof window !== 'undefined' &&
    window.localStorage?.getItem('USE_REAL_FIREBASE') === 'true') ||
  import.meta.env.VITE_USE_LIVE_BACKEND === 'true';

if (isDevelopment && appConfig.emulators && !useRealFirebase) {
  try {
    // Connect Auth emulator
    if (appConfig.emulators.auth.url) {
      connectAuthEmulator(auth, appConfig.emulators.auth.url, {
        disableWarnings: true,
      });
    }

    // Connect Firestore emulator
    if (
      appConfig.emulators.firestore.host &&
      appConfig.emulators.firestore.port
    ) {
      connectFirestoreEmulator(
        db,
        appConfig.emulators.firestore.host,
        appConfig.emulators.firestore.port
      );
    }

    // Connect Storage emulator (default port 9199)
    connectStorageEmulator(storage, appConfig.emulators.firestore.host, 9199);

    console.log('🔥 Connected to Firebase emulators');
  } catch (error) {
    console.warn('⚠️ Firebase emulator connection failed:', error);
  }
} else if (isDevelopment && useRealFirebase) {
  console.log('🌐 Using real Firebase services (emulators disabled)');
}

// Export types for use throughout the application
export type { User } from 'firebase/auth';
export type {
  DocumentData,
  QueryDocumentSnapshot,
  Timestamp,
} from 'firebase/firestore';
